import { FC, forwardRef, PropsWithChildren } from 'react';
import { Box, BoxProps, SxProps, Theme } from '@mui/material';
import { CardDeleteButton } from '../buttons';
import { clsx } from '../../utils';
import { cardStyle } from './card.styles';

export interface CardProps extends BoxProps {
	sx?: SxProps<Theme>;
	deleteButtonTooltip?: string;
	deleteButtonDisabled?: boolean
	onDelete?(): void;
}

export const Card = forwardRef((props: Omit<PropsWithChildren<CardProps>, 'ref'>, ref) => {
	const { children, deleteButtonDisabled, deleteButtonTooltip, onDelete, sx, ...restProps } = props;

	return (
		<Box {...restProps} sx={clsx(cardStyle, sx)} ref={ref}>
			{onDelete && (
				<CardDeleteButton
					tooltip={deleteButtonTooltip}
					disabled={deleteButtonDisabled}
					onDelete={onDelete}
				/>
			)}

			{children}
		</Box>
	);
});
